import { ErrorString, InvalidOperationException } from "../../shared/index.js";
import { toArray } from "./toArray.js";
export const singleOrDefault = (source, predicate) => {
    if (predicate) {
        return singleOrDefault2(source, predicate);
    }
    else {
        return singleOrDefault1(source);
    }
};
const singleOrDefault1 = async (source) => {
    const dataFunc = source.dataFunc;
    switch (dataFunc.type) {
        case 0: {
            const results = await dataFunc.generator();
            if (results.length > 1) {
                throw new InvalidOperationException(ErrorString.MoreThanOneElement);
            }
            else if (results.length === 0) {
                return null;
            }
            return results[0];
        }
        case 1: {
            const results = dataFunc.generator();
            if (results.length > 1) {
                throw new InvalidOperationException(ErrorString.MoreThanOneElement);
            }
            else if (results.length === 0) {
                return null;
            }
            return results[0];
        }
        case 2: {
            const results = await dataFunc.generator();
            if (results.length > 1) {
                throw new InvalidOperationException(ErrorString.MoreThanOneElement);
            }
            else if (results.length === 0) {
                return null;
            }
            return await results[0];
        }
    }
};
const singleOrDefault2 = async (source, predicate) => {
    const results = await toArray(source);
    let hasValue = false;
    let singleValue = null;
    for (const value of results) {
        if (predicate(value)) {
            if (hasValue === true) {
                throw new InvalidOperationException(ErrorString.MoreThanOneElement);
            }
            else {
                hasValue = true;
                singleValue = value;
            }
        }
    }
    return singleValue;
};
